
import { defineComponent, reactive, ComputedRef, onMounted, Ref, ref, toRef, toRefs, watch, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'


import { Props, validateInfos } from 'ant-design-vue/lib/form/useForm'
import { message, Form, Modal } from 'ant-design-vue'
const useForm = Form.useForm;
import useI18nAntdFormVaildateInfos from '@/composables/useI18nAntdFormVaildateInfos'
import {cloneDeep} from 'lodash'
import dayjs from 'dayjs'

import { LoadingOutlined,PlusOutlined,EditOutlined, CloudUploadOutlined, ExclamationCircleOutlined } from '@ant-design/icons-vue'
import {PersonalFormData} from './data.d'
import {AreaParams,ImageUrlParams,ShipmentOrderType} from '@/services/data.d'

import {StateType as CuntryStateType} from '@/store/country'
import {StateType as AreaStateType} from '@/store/area'
import {StateType as UploadStateType} from '@/store/upload'
import {StateType as UserStateType} from '@/store/user'
import {StateType as FddsignStateType} from '@/store/fddsign'
import {StateType as PersonalStateType} from './store'

import {arealistFn} from '@/utils/array'
import prefix from '@/utils/countryPrefix'

import {isIdcard,isPhone,isRunNian} from '@/utils/validate'
import {beforeUploadTypeSize} from '@/utils/upload'
import {lt18gt65} from '@/utils/lt18gt65'

import bank from '@/utils/bank'
import { json } from 'stream/consumers'


interface PersonalSetupData{
    t: (key: string | number) => string
    resetFields: (newValues?: Props) => void;
    validateInfos: ComputedRef<validateInfos>;
    modelRef: PersonalFormData;
    countrylist:Ref<any>;
    arealist:Ref<any>;
    prefixlist: any;
    loadingF: Ref<boolean>;
    loadingP: Ref<boolean>;
    loadingM: Ref<boolean>;
    isMark: Ref<boolean>;
    visible: Ref<boolean>;
    fddurl: Ref<string>;
    imageFrontUrl: Ref<string>;
    imageOppositeUrl: Ref<string>;
    certStatus: Ref<number | null>;
    isExitBank: Ref<boolean>;
    banklist: any;
    handleSubmit: (e:MouseEvent) => void;
    handleUploadFront: (info:any) => void;
    handleUploadOpposite: (info:any) => void;
    filterOption: (input:string,option:any) => any;
    handleChange: (val: string) => void;
    handleModfiy: (val: string) => void;
    fddModal: (type: string, params?: any) => void;
    handleChangeForever: (val:any) => void;
    beforeUpload: (info: any) => void;
    handleCancel: (e: MouseEvent) => void;
}

export default defineComponent({
    name: 'Personal',
    components: {
        LoadingOutlined,
        PlusOutlined,
        EditOutlined,
        CloudUploadOutlined,
        ExclamationCircleOutlined,
    },
    props: {
        phoneNumber: {
            type: String
        }
    },
    emits: ['changeCertStatus'],
    setup(props, {emit}):PersonalSetupData {
        const { t } = useI18n()
        const store = useStore<{
            country: CuntryStateType,
            area: AreaStateType,
            personal: PersonalStateType,
            upload: UploadStateType,
            user: UserStateType,
            fddsign: FddsignStateType
        }>()
        const countrylist = ref<any>([])
        const arealist = ref<any>([])
        const userMsg = JSON.parse(String(localStorage.getItem('userMsg'))) || {}
        const prefixlist = prefix
        const loadingF = ref<boolean>(false)
        const loadingP = ref<boolean>(false)
        const loadingM = ref<boolean>(false)
        const isMark = ref<boolean>(false)
        const visible = ref<boolean>(false)
        const fddurl = ref<string>('')
        const isExitBank = ref<boolean>(true)
        const imageFrontUrl = ref<string>('')
        const imageOppositeUrl = ref<string>('')
        const email = userMsg?.email ?? ''
        const usertype = store.state.user.currentUser.userType || 1
        const userExtend = store.state.user.currentUser.userExtend
        const bankDepositRegionData = usertype == 1 ? userExtend&&userExtend?.bankDepositRegion!=''&&JSON.parse(userExtend?.bankDepositRegion as any) : []
        const mobilePrefix = store.state.user.currentUser.mobilePrefix
        const certStatus = ref<number | null>(store.state.user.currentUser.certStatus ?? null)
        const banklist = bank || []
        let subnum = 0
        console.log('userExtend',userExtend);
        const modelRef = reactive<PersonalFormData>({
            nationality: userExtend ? userExtend?.nationality :'', //国籍
            nameCn: userExtend ? userExtend?.nameCn : '', //中文姓名
            nameEn: userExtend ? userExtend?.nameEn : '', //英文姓名
            email: email, //邮箱
            mobilePrefix: mobilePrefix ?? '',
            phone: userExtend ? userExtend?.phone : '', //联系电话
            contactAddress: userExtend ? [userExtend?.province ?? '',userExtend?.city ?? '',userExtend?.region ?? ''] : [],//联系地址
            detailedAddress: userExtend ? userExtend?.detailedAddress : '', //详细地址
            certificateType: userExtend ? userExtend?.certificateType : null, //证件类型
            certificateNo: userExtend ? userExtend?.certificateNo : '', //证件号
            effectiveTime: userExtend ? [userExtend?.validityStartDate,userExtend?.validityEndDate] : [],//有效时间
            isForever: userExtend ? userExtend?.isForever : false,//是否永久
            certificateAnnex1: userExtend&&userExtend?.certificateAnnex!=='' ? userExtend&&JSON.parse(String(userExtend?.certificateAnnex))?.frontId : '', //上传正面结果
            certificateAnnex2: userExtend&&userExtend?.certificateAnnex!=='' ? userExtend&&JSON.parse(String(userExtend?.certificateAnnex))?.oppositeId : '', //上传反面结果
            bankId: userExtend ? userExtend?.bankId : '', //银行账号
            bankName: userExtend ? userExtend?.bankName : null, //开户银行
            subbranchName: userExtend ? userExtend?.subbranchName : '', //开户支行
            bankDepositRegion: bankDepositRegionData&&bankDepositRegionData!=''? (usertype == 1 ? [bankDepositRegionData.province,bankDepositRegionData.city,bankDepositRegionData.region] : []):[], //开户行所在省市
        })

        const rulesRef = reactive({
            nationality: [
                {
                    required: true,
                    message: '请选择国籍'
                }
            ],
            nameCn:[
                {
                    required: true,
                    message: '请输入中文名'
                }
            ],
            nameEn:[
                {
                    required: false,
                    message: '请输入英文名'
                }
            ],
            email:[
                {
                    required: true,
                    message: '请输入邮箱'
                }
            ],
            mobilePrefix: [],
            phone:[
                {
                    required: true,
                    validator: (rule:any,value:string, callback: any)=>{
                        if(value===''|| value==undefined){
                            return Promise.reject('请输入联系电话')
                        }else{
                            if(isPhone(value)){
                                return Promise.resolve()
                            }else{
                                return Promise.reject('请输入正确的手机号电话')
                            }
                        }
                    }
                }
            ],
            contactAddress:[
                {
                    required: true,
                    message: '请选择联系地址'
                }
            ],
            detailedAddress:[
                {
                    required: true,
                    message: '请输入详细地址'
                }
            ],
            certificateType:[
                {
                    required: true,
                    message: '请选择身份证类型'
                }
            ],
            certificateNo:[
                {
                    required: true,
                    validator: (rule: any, value: string, callback: any) => {
                        if(value == ''|| value==undefined){
                            return Promise.reject('请输入身份证号')
                        }else if(value.length === 18&&isIdcard(value)){
                            if((
                                value.substring(10,12)=='04'||
                                value.substring(10,12)=='06'||
                                value.substring(10,12)=='09'||
                                value.substring(10,12)=='11'
                            )&&value.substring(12,14)>='31'||value.substring(10,12)>='13'){
                                return Promise.reject('请输入正确的身份证号')
                            }else if((
                                value.substring(10,12)=='01'||
                                value.substring(10,12)=='03'||
                                value.substring(10,12)=='05'||
                                value.substring(10,12)=='07'||
                                value.substring(10,12)=='08'||
                                value.substring(10,12)=='10'||
                                value.substring(10,12)=='12'
                            )&&value.substring(12,14)>='32'||value.substring(10,12)>='13'){
                                return Promise.reject('请输入正确的身份证号')
                            }else if(isRunNian(value.substring(6,10))){//润年
                                if(value.substring(10,12)=='02'&&value.substring(12,14)>='30'){
                                    return Promise.reject('请输入正确的身份证号')
                                }else{
                                    return Promise.resolve()
                                }
                            }else{
                                if(value.substring(10,12)=='02'&&value.substring(12,14)>='29'){
                                    return Promise.reject('请输入正确的身份证号')
                                }else{
                                    return Promise.resolve()
                                }
                            }
                        }else{
                            return Promise.reject('请输入正确的身份证号')
                        }
                    }
                }
            ],
            effectiveTime: [
                {
                    required: true,
                    validator: (rule: any, value: string, callback: any) => {
                        if(!modelRef.isForever){
                            if(value == ''|| value==undefined || value[0]==null&&value[1]===null){
                                return Promise.reject('请选择有效时间')
                            }else{
                                return Promise.resolve()
                            }
                        }else{
                            return Promise.resolve()
                        }
                    }
                }
            ],
            isForever: [{
                required: false,
            }],
            certificateAnnex1: [
                {
                    required: true,
                    message: '请上传证件正面图片'
                }
            ],
            certificateAnnex2: [
                {
                    required: true,
                    message: '请上传证件反面图片'
                }
            ],
            bankId: [{
                required: false,
                message: '请输入银行账号'
            }], //银行账号
            bankName: [{
                required: false,
                message: '请输入开户银行'
            }], //开户银行
            subbranchName: [{
                required: false,
                message: '请输入开户支行'
            }], //开户支行
            bankDepositRegion: [{
              required: false,
              message: '开户行所在省市'
            }], //开户行所在省市
        })
        const { resetFields, validate, validateInfos } = useForm(modelRef, rulesRef)
        const validateInfosNew = useI18nAntdFormVaildateInfos(validateInfos)
        const handleSubmit = async(e:MouseEvent)=>{
            e.preventDefault()
            try {
                const fieldsValue = await validate<PersonalFormData>()
                const st = fieldsValue.effectiveTime&&fieldsValue.effectiveTime[0] || ''
                const et = fieldsValue.effectiveTime&&fieldsValue.effectiveTime[1] || ''
                const startTime = st === '' ? '' : dayjs(st).format('YYYY-MM-DD')
                const endTime = et === '' ? '' : dayjs(et).format('YYYY-MM-DD')
                const province = fieldsValue?.contactAddress[0] ?? ''
                const city = fieldsValue?.contactAddress[1] ?? ''
                const region = fieldsValue?.contactAddress[2] ?? ''
                const params = cloneDeep(fieldsValue)
                const bankDepositRegionNew = (params.bankDepositRegion as any[])
                const bankDepositRegion = {
                    province:bankDepositRegionNew[0],
                    city:bankDepositRegionNew[1],
                    region:bankDepositRegionNew[2]
                }
                params.nationality = countrylist.value.filter((item:any)=>item.name==params.nationality)[0]?.countryCode ?? ''
                params['province'] = province
                params['city'] = city
                params['region'] = region
                params['validityStartDate'] = startTime
                params['validityEndDate'] = endTime
                params['userCode'] = userMsg?.userCode
                params['userType'] = usertype
                params['certificateAnnex'] = JSON.stringify({frontId: params.certificateAnnex1,oppositeId: params.certificateAnnex2})
                params['bankDepositRegion'] = JSON.stringify(bankDepositRegion)
                delete params.effectiveTime
                delete params.contactAddress
                delete params.certificateAnnex1
                delete params.certificateAnnex2
                console.log('params', params);
                if(params.certificateType==1){
                    if(lt18gt65(params.certificateNo)){
                        const res: boolean = await store.dispatch('personal/saveUserExtendFn',params)
                        if(res === true){
                            const data = {
                                id1:{id:fieldsValue.certificateAnnex1},
                                id2:{id:fieldsValue.certificateAnnex2}
                            }
                            fddModal('first',data)
                        }
                    }else{
                        message.warning('18周岁以下，65周岁以上不允许进行注册')
                    }
                }else{
                    const res: boolean = await store.dispatch('personal/saveUserExtendFn',params)
                    if(res === true){
                        const data = {
                            id1:{id:fieldsValue.certificateAnnex1},
                            id2:{id:fieldsValue.certificateAnnex2}
                        }
                        fddModal('first',data)
                    }
                }
            } catch (error) {
                console.log(error);
            }
        }

        watch(()=>props.phoneNumber,(newValue)=>{
            if(userMsg?.certStatus == 1){
                modelRef.phone = newValue
            }
        })

        //获取国家-国籍
        const filterOption = (input: string, option: any) => {
            return option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        }
        const countryName = async() => {
            try {
                const res: boolean = await store.dispatch('country/getCountryFn')
                if(res===true){
                    countrylist.value = store.state.country.countryCn
                    modelRef.nationality = countrylist.value.filter((item:any)=>item.countryCode==userExtend?.nationality)[0]?.name ?? ''
                }
            } catch (error) {
                message.warning('error=>'+error)
            }
        }

        //获取地址
        const areaList = async(params:AreaParams) => {
            try {
                const res:boolean = await store.dispatch('area/getAreaFn', params)
                if(res){
                    arealist.value = arealistFn(store.state.area.arealist,1)
                }
            } catch (error) {
                message.warning('获取地区信息失败!')
            }
        }

        //上传身份证正面
        const handleUploadFront = (info:any) => {
            const formdata = new FormData()
            formdata.append('file', info.file)
            formdata.append('fileType', '1')
            uploadFront(formdata,'front')
        }

        //上传身份证反面
        const handleUploadOpposite = (info:any) => {
            const formdata = new FormData()
            formdata.append('file', info.file)
            formdata.append('fileType', '1')
            uploadFront(formdata,'oppo')
        }

        //上传前图片类型大小限制
        const beforeUpload = (info:any) => {
            return beforeUploadTypeSize(info)
        }

        //上传图片
        const uploadFront = async(params:any,type:string='') => {
            type=='front'? loadingF.value = true : loadingP.value = true
            try {
                const res:boolean = await store.dispatch('upload/uploadFileFn',params)
                if(res === true){
                    if(type=='front'){
                        modelRef.certificateAnnex1 = store.state.upload.uploadRes.id
                    }else{
                        modelRef.certificateAnnex2 = store.state.upload.uploadRes.id
                    }
                    const data = {id: store.state.upload.uploadRes.id}
                    imageUrlRes(data,type)
                }
            } catch (error) {
                message.warning('error=>'+error)
            }
            type=='front'? loadingF.value = false : loadingP.value = false
        }
        //获取返回的图片地址
        const imageUrlRes = async(params:ImageUrlParams,type:string='') => {
            try {
                const res:boolean = await store.dispatch('upload/getImgUrlFn',params)
                if(res === true){
                    if(type=='front'){
                        imageFrontUrl.value = store.state.upload.imageUrlRes.fileUrl
                    }else{
                        imageOppositeUrl.value = store.state.upload.imageUrlRes.fileUrl
                    }
                }
            } catch (error) {
                message.warning('error=>'+error)
            }
        }

        //选择国家后显示证件类型
        const handleChange = (val:string) => {
            if(val === '中国'){
                modelRef.certificateType = 1
            }else if(val === '中国台湾省' || val === '中国香港' || val === '香港' || val === '中国澳门' || val === '澳门'){
                modelRef.certificateType = 3
            }else{
                modelRef.certificateType = 2
            }
        }

        //成功后修改
        const handleModfiy = (val: string) => {
            console.log('object');
            // certStatus.value = null
            Modal.confirm({
                title: '提示',
                content: '修改个人信息，需要您重新进行账号认证及合同签署，确认是否修改？',
                okText: '确认',
                cancelText: '取消',
                onOk(){
                    isExitBank.value = false
                }
            })
        }

        //法大大认证
        const url = computed<string>(() => store.state.fddsign.signUrl)
        const fddAction = async(params:ShipmentOrderType, data?: any) => {
            loadingM.value = true
            try {
                const res: boolean = await store.dispatch('fddsign/fddAuthenticationFn', params)
                if(res===true){
                    data&&getPersonalInfo(data)
                    visible.value = true
                    fddurl.value = url.value
                }else{
                    data&&getPersonalInfo(data)
                }
            } catch (error) {
                message.warning('error=>'+error)
            }
            loadingM.value = false
        }

        //法大大认证弹框
        const fddModal = (type: string, params?: any) => {
            Modal.confirm({
                title: '提示',
                content: '请确认您的认证信息填写是否正确。',
                okText: '确认',
                cancelText: '取消',
                onOk(){
                    if(type === 'first'){
                        fddAction({userCode: userMsg?.userCode}, params)
                    }else{
                        fddAction({userCode: userMsg?.userCode}, params)
                    }
                },
                onCancel(){
                    subnum += 1
                    if(subnum < 2){
                        params&&getPersonalInfo(params)
                    }
                }
            })
        }

        //回调获取数据
        const getPersonalInfo = async(params?: any) => {
            try {
                const res: boolean = await store.dispatch('user/fetchCurrent', {userCode: userMsg?.userCode})
                if(res===true){
                    certStatus.value = store.state.user.currentUser.certStatus
                    imageUrlRes(params.id1,'front')
                    imageUrlRes(params.id2)
                    emit('changeCertStatus', true)
                }
            } catch (error) {
                message.warning('error=>'+error)
            }
        }

        //点击长期有效
        const handleChangeForever = (val: any) => {
            if(val.target.checked){
                rulesRef.effectiveTime[0].required = false
                modelRef.effectiveTime = []
            }else{
                rulesRef.effectiveTime[0].required = true
            }
        }

        //初始化
        const init = () => {
            countryName()
            areaList({countryCode: '156'})
            if(certStatus.value == 1){
                isExitBank.value = false
            }
            modelRef.certificateAnnex1 ? imageUrlRes({id: modelRef.certificateAnnex1},'front') : null
            modelRef.certificateAnnex2 ? imageUrlRes({id: modelRef.certificateAnnex2}) : null
        }

        //点击右上角关闭按钮回调
        let timer:any = null
        const handleCancel = (e: MouseEvent) => {
            isMark.value = true
            let num = 0
            timer = setInterval(()=>{
                num += 1
                if(num >= 5){
                    isMark.value = false
                    num = 0
                    clearInterval(timer)
                    location.reload()
                }
            },1000)
        }

        onMounted(()=>{
            init()
        })

        return {
            t,
            resetFields,
            modelRef,
            countrylist,
            arealist,
            validateInfos: validateInfosNew,
            filterOption,
            prefixlist,
            loadingF,
            loadingP,
            loadingM,
            isMark,
            visible,
            fddurl,
            imageFrontUrl,
            imageOppositeUrl,
            certStatus,
            banklist,
            handleSubmit,
            handleUploadFront,
            handleUploadOpposite,
            handleChange,
            handleModfiy,
            fddModal,
            handleChangeForever,
            beforeUpload,
            handleCancel,
            isExitBank
        }
    }
})
